"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _webViewConnect = _interopRequireDefault(require("../webViewConnect"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var versionCompare = function versionCompare() {
  var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!v1) {
    v1 = '';
  }

  if (!v2) {
    v2 = '';
  }

  if (typeof v1 === 'number') {
    v1 = '0' + v1;
    v1 = v1.substr(1, v1.length - 1);
  }

  if (typeof v2 === 'number') {
    v2 = '0' + v2;
    v2 = v2.substr(1, v2.length - 1);
  }

  if (v1 === v2) {
    return v1 + '和' + v2 + '版本一样高';
  }

  var v1Arry = v1.split('.');
  var v2Arry = v2.split('.');

  var _iterator = _createForOfIteratorHelper(v1Arry.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
          i = _step$value[0],
          element = _step$value[1];

      if (i > v2Arry.length) {
        return v1 + '版本高';
      } else {
        if (parseInt(element) > parseInt(v2Arry[i])) {
          return v1 + '版本高';
        } else if (parseInt(element) < parseInt(v2Arry[i])) {
          return v2 + '版本高';
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return v2 + '版本高';
};

var _versionCompareNew = function _versionCompareNew() {
  var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!v1) {
    v1 = '';
  }

  if (!v2) {
    v2 = '';
  }

  if (typeof v1 === 'number') {
    v1 = '0' + v1;
    v1 = v1.substr(1, v1.length - 1);
  }

  if (typeof v2 === 'number') {
    v2 = '0' + v2;
    v2 = v2.substr(1, v2.length - 1);
  }

  if (v1 === v2) {
    return '=';
  }

  var v1Arry = v1.split('.');
  var v2Arry = v2.split('.');

  var _iterator2 = _createForOfIteratorHelper(v1Arry.entries()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = (0, _slicedToArray2["default"])(_step2.value, 2),
          i = _step2$value[0],
          element = _step2$value[1];

      if (i > v2Arry.length) {
        return '>';
      } else {
        if (parseInt(element) > parseInt(v2Arry[i])) {
          return '>';
        } else if (parseInt(element) < parseInt(v2Arry[i])) {
          return '<';
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return '<';
};

var _compare = function _compare(version) {
  try {
    if (!version) {
      console.warn('VERSION 为空');
      return false;
    }

    var curAppVersion = _webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.versionName);

    if (!curAppVersion) {
      console.warn('curAppVersion 为空');
      return false;
    }

    var res = _versionCompareNew(curAppVersion || '', version);

    console.log(curAppVersion, res, version);
    return res;
  } catch (error) {
    console.error(error);
    return false;
  }
};

var cur$Version = {
  '>': function _(version) {
    return _compare(version) === '>';
  },
  '<': function _(version) {
    return _compare(version) === '<';
  },
  '>=': function _(version) {
    return ['>', '='].includes(_compare(version));
  },
  '<=': function _(version) {
    return ['<', '='].includes(_compare(version));
  },
  '==': function _(version) {
    return _compare(version) === '=';
  }
};
var _default = {
  cur$Version: cur$Version,
  versionCompare: versionCompare
};
exports["default"] = _default;